import { render, staticRenderFns } from "./AwardLogreview.vue?vue&type=template&id=90a5bd90&scoped=true"
import script from "./AwardLogreview.vue?vue&type=script&lang=js"
export * from "./AwardLogreview.vue?vue&type=script&lang=js"
import style0 from "./AwardLogreview.vue?vue&type=style&index=0&id=90a5bd90&prod&lang=css"
import style1 from "./AwardLogreview.vue?vue&type=style&index=1&id=90a5bd90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a5bd90",
  null
  
)

export default component.exports